<template>
  <div>
    <v-select
      transition=""
      @option:selected="onChanges()"
      v-if="mount"
      name="SELECT2"
      v-model="selected"
      class="select-2-component"
      :reduce="name => name.value ?? name.id"
      :label="prop_name"
      :options="options"
      :filterable="prop_filterable"
      :placeholder="prop_placeholder"
      @search="onSearch"
    >
      <template #search="{ attributes, events }">
        <input class="vs__search"
               v-bind="attributes"
               v-on="events"
               :required="!selected && !!prop_required"
        >
        <input type="hidden" :name="prop_value" v-model="selected">
      </template>
      <template v-slot:no-options="{ search, searching }">
        <template v-if="searching">
          {{ trans('select2.not_found') }}
        </template>
      </template>

    </v-select>


  </div>
</template>

<script>
export default {
  name: "Select2Component",
  props: ['prop_options', 'prop_name', 'prop_value', 'prop_required', 'prop_filterable', 'prop_placeholder'],
  emits: ['changes', 'search'],

  data() {
    return {
      selected: null,
      mount: false,
      options: [],
    }
  },
  watch: {
    prop_options: {
      handler(val) {
        this.options = val
      }
    },
    prop_value: {
      handler(val) {
        this.selected = val
      }
    }
  },
  async mounted() {
    try {
      this.options = JSON.parse(this.prop_options)
    } catch (e) {
      this.options = this.prop_options;
    }

    this.mount = true
  },
  methods: {
    setSelected(value) {
      this.selected = value
    },
    onChanges() {
      this.$emit('changes', this.selected)
    },
    onSearch(value) {
      this.$emit('search', value)
    },
  },
}
</script>

<style scoped>

</style>
